import { inject, Injectable } from '@angular/core';
import { SERVICE_CONFIG_TOKEN, ServiceConfig } from '@web/csl-lib-services';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ScpUploadWorklistItem } from '../../models/scp-upload-worklist-item';

@Injectable({
  providedIn: 'root'
})
export class ScpUploadWorklistService {

  private serviceConfig: ServiceConfig;
  private http!: HttpClient;
  private readonly apiUrl! : string;

  constructor() {
    this.http = inject(HttpClient);
    this.serviceConfig = inject(SERVICE_CONFIG_TOKEN);
    this.apiUrl = this.serviceConfig.apiUrl;
  }

  getWorklist(clinicId: number, statusFilter?: number[]): Observable<ScpUploadWorklistItem[]> {
    const filterValues = statusFilter?.join(',');
    const filter = (filterValues && filterValues.length > 0) ? `?filter=${filterValues}` : '';

    return this.http.get<ScpUploadWorklistItem[]>(`${this.apiUrl}/clinics/${clinicId}/scpworklist${filter}`);
  }

  updateStatus(clinicId: number, worklistItemId: number, newStatus: number): Observable<ScpUploadWorklistItem> {
    return this.http.patch<ScpUploadWorklistItem>(`${this.apiUrl}/clinics/${clinicId}/scpworklist/${worklistItemId}`,
      { status: newStatus });
  }

  getQueuedCount(clinicId: number): Observable<number> {
    return this.http.get<number>(`${this.apiUrl}/clinics/${clinicId}/scpworklist/queuedCount`);
  }

  removeFromWorklist(clinicId: number, healthRecordId: string): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/clinics/${clinicId}/scpworklist/${healthRecordId}`);
  }

  addToScpUploadWorklist(clinicId: number, healthRecordId: string): Observable<void> {
    return this.http.post<void>(`${this.apiUrl}/clinics/${clinicId}/scpworklist/${healthRecordId}`, {});
  }

}
